import React, { useEffect, useState } from "react";
import { Checkbox, Col, Input, message, Modal, Row } from "antd";
import style from "./index.module.scss";
import { TopicItem } from "../../../../../service/exercise";

interface TopicTypeAddModalProps {
    visible: boolean;
    typeList: TopicItem[];
    id?: string;
    description?: string;
    basicTypeIds?: string;
    isHaveQuestion?: string; //题型下面是否有题0:没有1:有
    onCancel: () => void;
    onOk: (topicId: string, description: string, basicTypeIds: string) => void;
}

export default function TopicTypeAddModal({
    visible,
    typeList,
    id,
    description,
    basicTypeIds,
    isHaveQuestion,
    onCancel,
    onOk
}: TopicTypeAddModalProps) {
    const [topicId, setTopicId] = useState("");
    const [inputVal, setInputVal] = useState("");
    const [selectVal, setSelectVal] = useState<any>([]);

    useEffect(() => {
        if (id) {
            setTopicId(id);
        } else {
            //没有id是添加题型，需要清空之前可能存在的值
            setTopicId("");
            setInputVal("");
            setSelectVal([]);
        }
        if (basicTypeIds) {
            setSelectVal(
                basicTypeIds
                    .toString()
                    .split(",")
                    .map(val => {
                        return parseInt(val);
                    })
            );
        }
        if (description) {
            setInputVal(description);
        }
    }, [visible]);

    function checkBoxChange(val: any) {
        setSelectVal(val);
    }

    function modalOk() {
        if (inputVal === "") {
            return message.error("题型名称必填，请输入题型名称！");
        }
        if (selectVal.length === 0) {
            return message.error("选择题型为必填项，请至少选择一个题型！");
        }
        onOk(topicId, inputVal, selectVal.join(","));
        onCancel();
    }
    function modalCancel() {
        if (id) {
            if (
                inputVal !== description ||
                selectVal.join(",") !== basicTypeIds
            ) {
                Modal.confirm({
                    title: "提示",
                    content: `页面输入内容未保存，您确定离开此页面吗?`,
                    onOk: () => clearData()
                });
            } else {
                onCancel();
            }
        } else {
            if (inputVal !== "" || selectVal.length !== 0) {
                Modal.confirm({
                    title: "提示",
                    content: `页面输入内容未保存，您确定离开此页面吗?`,
                    onOk: () => clearData()
                });
            } else {
                onCancel();
            }
        }
    }

    function clearData() {
        onCancel();
        setTopicId("");
        setInputVal("");
        setSelectVal([]);
    }

    function checkDisable(id: string) {
        //如果该题型下已添加题目，那么已被选中的题型不可取消选择，仅可以增加选择题型
        return isHaveQuestion == "1" && basicTypeIds?.indexOf(id) !== -1;
    }

    return (
        <Modal
            title={id ? "编辑题型" : "添加题型"}
            visible={visible}
            onOk={modalOk}
            onCancel={modalCancel}
            className={style.root}
            centered
            okText="确认">
            <Row gutter={[20, 20]}>
                <Col span={8} className={style.label}>
                    <i className={style.required}>*</i>题型名称：
                </Col>
                <Col span={14}>
                    <Input
                        placeholder="请输入题型名称"
                        maxLength={500}
                        value={inputVal}
                        onChange={e => setInputVal(e.target.value)}
                    />
                </Col>
            </Row>

            <Row gutter={[20, 20]}>
                <Col span={8} className={style.label}>
                    <i className={style.required}>*</i>选择题型：
                </Col>
                <Col span={14}>
                    {selectVal && (
                        <Checkbox.Group
                            value={selectVal}
                            onChange={val => checkBoxChange(val)}>
                            {typeList &&
                                typeList.map(item => {
                                    return (
                                        <Checkbox
                                            disabled={checkDisable(item.id)}
                                            key={item.id}
                                            value={item.id}>
                                            {item.description}
                                        </Checkbox>
                                    );
                                })}
                        </Checkbox.Group>
                    )}
                </Col>
            </Row>
        </Modal>
    );
}
